import moment from "moment";
import { connect } from "react-redux";
import { Card, CardBody, Row, Col } from "reactstrap";

const mapStateToProps = (state) => ({
  currentProfile: state.Login.currentProfile
})

const GetProfile = (props) => {
  const { currentProfile } = props;
  const profile = currentProfile && currentProfile.userProfile;
  const license = currentProfile && currentProfile.licenseInfo
  return (
    <>
      <Card>
        <CardBody>
          <h6><strong>Profile Details</strong></h6>
          <hr />
          <Row className="justify-content-center">
            <Col xl="9">
              {/* Main card */}
              <div className="card b">
                <div className="card-header">
                  <h4 className="my-2">
                    <span>{profile && profile.displayName}</span>
                  </h4>
                </div>
                <div className="card-body bt">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                <strong>First name</strong>
                              </td>
                              <td>{profile && profile.firstName}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Last name</strong>
                              </td>
                              <td>{profile && profile.lastName}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Display name</strong>
                              </td>
                              <td>{profile && profile.displayName}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Email</strong>
                              </td>
                              <td>{profile && profile.email}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Organisation</strong>
                              </td>
                              <td>{profile && profile.orgName || 'NA'}</td>
                            </tr>

                          </tbody>
                        </table><br />

                        <Card>
                          <CardBody>
                            <h4><strong>License Details</strong></h4>
                          </CardBody>
                        </Card>
                        <table className="table table-bordered table-striped table-hover">
                          <tbody>
                            {/*
                            <tr>
                              <td>
                                <strong>Granted By</strong>
                              </td>
                              <td>{license?.grantedBy}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Grant Date</strong>
                              </td>
                              <td>{license?.grantDate}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Updated Date</strong>
                              </td>
                              <td>{license?.updatedDate}</td>
                            </tr>
                            */}
                            <tr>
                              <td>
                                <strong>Valid Upto</strong>
                              </td>
                              <td>{license && license.validUpto ? moment(license && license.validUpto).format('DD MMM YYYY') : ''}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  )
}

export default connect(mapStateToProps, null)(GetProfile);